import { Toaster } from "sonner";
import Outlet from "@/common/Outlet";
import Header from "@/components/Header";
import { ScrollRestoration } from "react-router";
import Footer from "@/components/Footer";
import { Loading01Icon } from "@/icons";
import { Announcement } from "@/components/Announcement";
import { graphql, Environment } from "react-relay";
import { ScaffoldQuery as ScaffoldQueryType } from "./__generated__/ScaffoldQuery.graphql";
import { preload, usePreloaded } from "@/utils/relay";
import { LoaderArgs } from "@/utils/route";
export default function Scaffold() {
  const { query } = useScaffoldQuery();
  return (
    <div className="bg-background min-h-screen flex flex-col">
      <Announcement query={query} />
      <Header query={query} />
      <section className="grow bg-white space-y-6 flex flex-col sm:pb-16 pb-14">
        <Toaster
          richColors
          icons={{
            loading: <Loading01Icon className="animate-spin w-4 h-4" />,
          }}
        />
        <Outlet />
        <ScrollRestoration />
      </section>
      <Footer />
    </div>
  );
}
const ScaffoldQuery = graphql`
  query ScaffoldQuery($targetPath: String!) {
    ...HeaderFragment
    ...AnnouncementFragment @arguments(targetPath: $targetPath)
  }
`;
export const loader = (environment: Environment) => {
  return ({ request }: LoaderArgs) => {
    const url = new URL(request.url);
    return preload<ScaffoldQueryType>(environment, ScaffoldQuery, {
      targetPath: url.pathname,
    });
  };
};
const useScaffoldQuery = () => usePreloaded<ScaffoldQueryType>();
